export default {
    ADD_NOTE : 'ADD_NOTE',
    REMOVE_NOTE : 'REMOVE_NOTE',
    UPDATE_NOTE : "UPDATE_NOTE",

    SET_INPUT_TITLE : "SET_INPUT",
    SET_INPUT_CONTENT : "SET_INPUT_CONTENT",
    SET_INPUT_ID : "SET_INPUT_ID",
    RESET_INPUT : "RESET_INPUT"
}